import { createAsyncThunk } from '@reduxjs/toolkit';

import axiosInterceptorInstance from './axiosInterceptorInstance';

export const getAffiliateInfo = createAsyncThunk(
  'affiliate',
  async (agentId: string) => {
    try {
      const relativeUrl = `Affiliate/${agentId}`;
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);
